import React, { lazy, Suspense } from 'react';
import CWOConfigProvider from 'helpers/cwoConfigProvider';
import Loading from 'helpers/loading/loading';

const FormSelectCustomDropdown = lazy(() => import('components/form-select-custom-dropdown'));

const FormSelectCustomDropdownComponent = (props) => (
  <CWOConfigProvider>
    <Suspense fallback={<Loading />}>
      <FormSelectCustomDropdown {...props} />
    </Suspense>
  </CWOConfigProvider>
);

export default FormSelectCustomDropdownComponent;
